import r from "../managers/braze-instance.js";
import { MUST_BE_IN_APP_MESSAGE_WARNING as sr } from "../common/constants.js";
import InAppMessage from "./models/in-app-message.js";
import InAppMessageButton from "./models/in-app-message-button.js";
import se from "./in-app-message-manager-factory.js";
import { logger as E } from "../../shared-lib/index.js";
import ot from "../triggers/models/trigger-events.js";
import { TriggersProviderFactory as rt } from "../triggers/triggers-provider-factory.js";
export function logInAppMessageButtonClick(o, t) {
  var e;
  if (!r.rr()) return !1;
  if (!(o instanceof InAppMessageButton)) return E.error("button must be an InAppMessageButton object"), !1;
  if (!(t instanceof InAppMessage)) return E.error(sr), !1;
  var s = se.ea().Xi(o, t);
  if (s.W) for (var _r = 0; _r < s.ue.length; _r++) rt.o().ve(ot.Qr, [t.triggerId, null === (e = o.id) || void 0 === e ? void 0 : e.toString()], s.ue[_r]);
  return s.W;
}